import { useEffect } from 'react';

import {
	createActionsHook,
	createContainer,
	createDefaultEocWrapper,
	createHook,
	createStore,
} from '@atlassian/eoc-rss-helpers';

import { useUiPreferences } from '../preferences';

import { actions } from './actions';
import { initialState } from './state';
import { type ContainerProps } from './types';

const store = createStore<typeof initialState, typeof actions>({
	initialState,
	actions,
});

const useActions = createActionsHook<typeof initialState, typeof actions>(store);

const useStore = createHook<typeof initialState, typeof actions>(store);

const Container = createContainer<typeof initialState, typeof actions, ContainerProps>(store, {
	Wrapper: createDefaultEocWrapper({
		useContainerHook: () => {
			const { init } = useActions();
			const { schedulePreferences, schedulesCollapsed } = useUiPreferences();

			useEffect(() => {
				init(schedulesCollapsed, schedulePreferences);
			}, [init, schedulePreferences, schedulesCollapsed]);
		},
	}),
});

export { Container, useStore, useActions, store };
